import axios from 'axios';
import Cookies from 'js-cookie';
export default {
    init() {
        this.initialLoadAmount = 10;
        this.currOffset = this.initialLoadAmount;
        this.loadMoreAmount = 5;
        this.printablePosts = [];
        //if the search variable is set.
        if(typeof search !== 'undefined' && search && search.results) {
            search.results = search.results.filter(post => {
                return post !== null;
            })
            //getting the load more button.
            this.loadMore = document.querySelector('#load-more');
            //the container to append the results to.
            this.container = document.querySelector('.search-page__results');
            this.filters = document.querySelectorAll('.filter__radio');

            this.printablePosts = search.results;

            this.searchTerm = this.container.dataset.searchTerm;
            this.searchResultInitialize();

            if(this.loadMore) {
                this.loadMore.addEventListener('click', e => {
                    this.loadMorePosts();
                });
            }

            if(this.filters) {
                console.log("search.js - All results: ", search.results);
                Array.from(this.filters).forEach(filter => {
                    filter.addEventListener('click', e => {
                        let activeFilters = document.querySelectorAll('.filter__radio:checked');
                        let postTypes = [];
                        Array.from(activeFilters).forEach(activeFilter => {
                            postTypes.push(activeFilter.value);
                        });

                        console.log("search.js - Post types: ", postTypes);
                        this.printablePosts = search.results.filter(post => {
                            return post && post.post_type && postTypes.includes(post.post_type);
                        })
                        
                        console.log("search.js - all posts: " + search.results.length + " filtered: ", this.printablePosts.length);
                        this.filterLoad();
                    });
                })
            }
        }
    },
    loadMorePosts: function () {
        let nextLoad = this.printablePosts.slice(this.currOffset, this.currOffset + this.loadMoreAmount);
        this.currOffset += this.loadMoreAmount;
        if(this.container && Array.isArray(nextLoad)) {
            this.load(nextLoad, true);
        }
        console.log(nextLoad);

        if(this.currOffset + this.loadMoreAmount >= this.printablePosts.length) {
            this.hideLoadButton();
        }

        this.searchTerm = this.container.dataset.searchTerm;
    },
    hideLoadButton: function() {
        if(this.loadMore) {
            this.loadMore.classList.add('hidden');
        }
    },
    showLoadButton: function() {
        if(this.loadMore) {
            this.loadMore.classList.remove('hidden');
        }
    },
    load(posts, append = true) {
        // container.innerHTML += String(nextLoad);
        const post = axios.post('/wp-json/queries/search-ajax', {
            'posts': posts,
        }).then(res => {
            if(append) {
                this.container.innerHTML += res.data;
            } else {
                this.container.innerHTML = res.data;
            }

            this.searchResultInitialize();
        }).catch(e => {
            console.warn(e);
        })

        this.searchTerm = this.container.dataset.searchTerm;
    },
    filterLoad() {
        if(this.printablePosts.length > 10)
            this.showLoadButton();
        else
            this.hideLoadButton();

        let posts = this.printablePosts.slice(0, this.initialLoadAmount);
        this.currOffset = this.initialLoadAmount;

        if(this.container && Array.isArray(posts)) {
            this.load(posts, false);
        }
    },
    searchResultInitialize() {
        let results = document.querySelectorAll('.search-result > a');
        if(!this.searchTerm) {
            console.warn("search.js - search-page__results missing data-search-term. Aborting");
            return;
        }

        if(this.searchTerm) {
            Array.from(results).forEach(res => {
                let postType = res.dataset.postType;
                let id = res.dataset.id;
                if(postType && id) {
                    let click = (e) => {
                        this.searchResultClick(e, res);
                    }
                    res.removeEventListener('click', click);
                    res.addEventListener('click', click);
                }
            })
        }
    },
    searchResultClick(e, anchor) {
        e.preventDefault();
        let postType = anchor.dataset.postType;
        let id = anchor.dataset.id;
        Cookies.set('searchTerm', this.searchTerm);
        Cookies.set('searchPostType', postType);
        Cookies.set('searchId', id);
        window.location = anchor.href;
    }
}